import { getRegions } from '@/api/dict'

/**
 * 获取拉平区域列表
 *
 * @param trreeData 区域树形数据
 * @returns 区域列表
 */
const getRegionList = (trreeData) => {
  const list = []
  trreeData.forEach((item) => {
    list.push({
      text: item.text,
      value: item.value
    })
    if (item.children && item.children.length) {
      list.push(...getRegionList(item.children))
    }
  })
  return list
}

/**
 * 获取省市数据
 * @param {*} treeData
 * @returns
 */
const getTreeCityData = (treeData) => {
  // 如果有三级，则删除三级
  return treeData.map(item => {
    if (item.children && item.children.length) {
      item.children = item.children.map(value => {
        if (value.children) {
          delete value.children
        }
        return value
      })
    }
    return item
  })
}

export default {
  namespaced: true,
  state: {
    // 省市县数据
    regionData: [],
    // 省市数据，用于列表
    regionCity: [],
    // 地区列表拉平数据，用于显示文字
    regionList: []
  },
  mutations: {
    setRegionData (state, data) {
      state.regionData = data
    },
    setRegionList (state, data) {
      state.regionList = data
    },
    setRegionCity (state, data) {
      state.regionCity = [...data]
    }
  },
  actions: {
    // 获取地区数据
    async getRegionData ({ commit }) {
      const BASIC = await getRegions()
      console.log(BASIC,"BASIC")
      if (!BASIC) return
      const { LOCATION } = BASIC
      if (!LOCATION || !LOCATION.length) return
      // 省市县数据
      commit('setRegionData', LOCATION[0].children)
      // 省市数据
      const provinceAndCity = getTreeCityData(JSON.parse(JSON.stringify(LOCATION[0].children)))
      commit('setRegionCity', provinceAndCity)
      // 拉平数据
      const list = getRegionList(LOCATION[0].children)
      commit('setRegionList', list)
    }
  }
}
